/**
 * FormHelp — Wraps a form/screen section with HelpContext.
 *
 * Usage:
 *   <FormHelp formName="ItemCreation" userRole={user.role}>
 *     <MyForm />
 *   </FormHelp>
 *
 * Automatically loads dictionary on mount (zero per-field requests).
 */
import React from 'react';
import { HelpProvider } from '../../context/HelpContext';

export function FormHelp({ children, formName, projectName = 'RetailERP', userRole = '' }) {
  return (
    <HelpProvider projectName={projectName} formName={formName} userRole={userRole}>
      {children}
    </HelpProvider>
  );
}
